import { render } from "./ProductOffer.vue?vue&type=template&id=44adf60f&scoped=true"
import script from "./ProductOffer.vue?vue&type=script&lang=js"
export * from "./ProductOffer.vue?vue&type=script&lang=js"

import "./ProductOffer.vue?vue&type=style&index=0&id=44adf60f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44adf60f"]])

export default __exports__